import React from "react";
import { Skeleton } from 'primereact/skeleton';


const TicketEditSkeleton = () => {
    return (
        <div className="ticket-edit-container">
            <div className="p-card">
                <div className="flex flex-row justify-content-between">
                    <Skeleton width="45rem" className="mb-2"></Skeleton>
                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                </div>
                <div className="mt-2">
                    <Skeleton width="100%" height="150px"></Skeleton>
                </div>
                <div className="flex flex-row mt-4">
                    <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2"></Skeleton>
                    <Skeleton shape="rectangle" height="2rem" width="16rem" className="mb-2 mr-2"></Skeleton>
                    <Skeleton shape="rectangle" height="2rem" width="10rem" className="mb-2 mr-2"></Skeleton>
                    <Skeleton shape="rectangle" height="2rem" width="6rem" className="mb-2 mr-2"></Skeleton>
                    <Skeleton shape="rectangle" height="2rem" width="7rem" className="mb-2 mr-2"></Skeleton>
                    <Skeleton shape="rectangle" height="2rem" width="16rem" className="mb-2"></Skeleton>
                </div>
                <div className="flex flex-row justify-content-between w-12">
                    <div className="flex flex-column w-10">
                        <div className="flex flex-row mt-2">
                            <Skeleton shape="rectangle" height="2rem" width="24rem" className="mb-2 mr-2 w-6"></Skeleton>
                            <Skeleton shape="rectangle" height="2rem" width="29rem" className="mb-2 mr-2 w-6"></Skeleton>
                        </div>
                        <div className="flex flex-row mt-2 ">
                            <Skeleton shape="rectangle" height="2rem" width="24rem" className="mb-2 mr-2 w-6"></Skeleton>
                            <Skeleton shape="rectangle" height="2rem" width="29rem" className="mb-2 mr-2 w-6"></Skeleton>
                        </div>
                    </div>
                    <div className=" flex w-2 mt-2 justify-content-end">
                        <Skeleton shape="square" height="5rem" width="5rem" className="mb-2"></Skeleton>
                    </div>
                </div>
                <div className="flex justify-content-center mt-3">
                    <Skeleton shape="rectangle" height="2rem" width="8rem" className="mb-2 mr-2"></Skeleton>
                </div>

            </div>
            <div className="p-card">
                <div className="flex mt-3">
                    <Skeleton shape="circle" size="3rem" className="mr-2" borderRadius="50%"></Skeleton>
                    <div style={{ flex: '1' }}>
                        <Skeleton width="30%" className="mb-2 mt-1"></Skeleton>
                        <Skeleton width="65%" ></Skeleton>
                    </div>
                </div>
                <div className="flex mt-3">
                    <Skeleton shape="circle" size="3rem" className="mr-2" borderRadius="50%"></Skeleton>
                    <div style={{ flex: '1' }}>
                        <Skeleton width="30%" className="mb-2 mt-1"></Skeleton>
                        <Skeleton width="65%" ></Skeleton>
                    </div>
                </div>
                <div className="flex mt-3">
                    <Skeleton shape="circle" size="3rem" className="mr-2" borderRadius="50%"></Skeleton>
                    <div style={{ flex: '1' }}>
                        <Skeleton width="30%" className="mb-2 mt-1"></Skeleton>
                        <Skeleton width="65%" ></Skeleton>
                    </div>
                </div>
                <div className="flex mt-3">
                    <Skeleton shape="circle" size="3rem" className="mr-2" borderRadius="50%"></Skeleton>
                    <div style={{ flex: '1' }}>
                        <Skeleton width="30%" className="mb-2 mt-1"></Skeleton>
                        <Skeleton width="65%" ></Skeleton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TicketEditSkeleton;